import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { theme } from "@/styles/theme";
import { TResultSheet } from "@/typings/Props";
import EcoSystem from "@/components/products/detail/EcoSystem";
import { media } from "@/styles/media";
import TabButton from "../TabButton";

export default function ResultSheetImage({ datas }: { datas: TResultSheet[] }) {
  const [tabId, setTabId] = useState(1);
  const router = useRouter();
  const { t } = useTranslation();

  useEffect(() => {
    setTabId(1);
  }, [router.asPath]);

  return (
    <ResultSheetWrapper>
      <TabButton
        items={datas.map((data) => ({ id: data.id, label: t(data.category) }))}
        activeId={tabId}
        onTabChange={setTabId}
      />
      {datas.map((data: TResultSheet) => {
        if (tabId == data.id) {
          return (
            <EcoSystemWrap key={data.id}>
              <EcoSystemContent>
                {data.spots && data.image && <EcoSystem isBlock ecoImg={data.image} ecoSystem={data.spots} />}
              </EcoSystemContent>
            </EcoSystemWrap>
          );
        }
      })}
    </ResultSheetWrapper>
  );
}

const ResultSheetWrapper = styled.div`
  margin-bottom: 50px;
  ${media.tablet`
    margin-bottom: initial;
  `}
`;
const EcoSystemWrap = styled.div`
  margin: 50px auto 0 auto;
  padding: 46px;
  max-width: 768px;
  border-radius: 10px;
  background-color: ${theme.colors.background.white};
`;
const EcoSystemContent = styled.div`
  position: relative;
  img {
    width: 100%;
    vertical-align: top;
  }
`;
